import { createListenerMiddleware } from '@reduxjs/toolkit';

import { buildGraphaelQueryOptions } from 'hooks/useGraphaelDefaults';
import { apolloClient } from 'hooks/withGraphQL';

import { setAutoplay } from 'store/modules/player';
import { setRecommendations } from 'store/modules/queue';
import ReduxState from 'store/ReduxState';

import {
  GetQueueRecommendationsDocument,
  GetQueueRecommendationsQuery,
  GetQueueRecommendationsQueryVariables,
} from './../../graphql/generated/graphql';

export const syncQueueWithAutoPlay = createListenerMiddleware<ReduxState>();

syncQueueWithAutoPlay.startListening({
  type: setAutoplay.type,
  effect: async (action: any, listenerApi) => {
    const state = listenerApi.getState();

    const currentlyPlaying = state.player.currentlyPlaying;

    if (!currentlyPlaying) return;

    listenerApi.cancelActiveListeners();

    if (action.payload) {
      const { data } = await apolloClient.query<
        GetQueueRecommendationsQuery,
        GetQueueRecommendationsQueryVariables
      >({
        ...buildGraphaelQueryOptions(
          state.auth.isAuthenticated,
          state.auth.headers,
          state.translations.locale,
        ),
        query: GetQueueRecommendationsDocument,
        variables: {
          campaign:
            state.recommendationsCampaigns['player.similarAudios'] || '',
          storyId: currentlyPlaying.id,
        },
      });
      const stories = data?.recommendedStories?.recommendedStories || [];

      if (stories.length > 0) {
        listenerApi.dispatch(setRecommendations(stories));
      }
    } else {
      listenerApi.dispatch(setRecommendations([]));
    }
  },
});
